'use es6';

import { Record } from 'immutable';
const PerRespondentTypeRecord = Record({
  detractor: undefined,
  passive: undefined,
  promoter: undefined
});
export default PerRespondentTypeRecord;